import { isEmpty } from 'lodash';
import { ACCOUNT_ID } from 'hooks/queryParams/useSelectedAccountId';
import { getParamDependentValues, queryParamHookFactory } from 'modules/taboola-common-frontend-modules/query-params';
import { PERSISTENCE_TYPE } from 'modules/taboola-common-frontend-modules/storage';
import { REPORT_SETTINGS_PREFIX } from 'modules/taboola-common-frontend-modules/storage/DBStorage/constant';
import { REPORT_SORTING_DYNAMIC_PROP } from '../../../../scheduled-reports/config/dynamicReportViewProps';
import { isStaticReport } from '../../../config/isStaticDynamicReport';
import { REPORT_ID } from './useSelectedReportId';

export const REPORT_SORTING = 'sorting';

export const emptySorting = [];

export const getStaticReportFilterKey = reportId => `${REPORT_SETTINGS_PREFIX}.${reportId}.sorting`;
export const getDynamicReportFilterKey = (reportId, accountId) =>
    `${accountId}.${reportId}.${REPORT_SORTING_DYNAMIC_PROP}`;

export const useReportSortingParam = queryParamHookFactory(REPORT_SORTING, {
    serializer: JSON.stringify,
    deserializer: value => {
        if (!value) {
            return;
        }

        if (typeof value !== 'string') {
            return value;
        }

        try {
            const parsedValue = JSON.parse(value);
            return parsedValue;
        } catch (err) {}
    },
    dependencies: { queryParams: [REPORT_ID, ACCOUNT_ID] },
    persist: PERSISTENCE_TYPE.REPORT_STORAGE,
    storageKeyGetter: (paramName, metadata) => {
        const dependentValues = getParamDependentValues(paramName, metadata);
        const reportId = dependentValues[REPORT_ID];

        if (isStaticReport(reportId)) {
            return getStaticReportFilterKey(dependentValues[REPORT_ID]);
        }

        return getDynamicReportFilterKey(reportId, dependentValues[ACCOUNT_ID]);
    },
});

export const useReportSorting = reportConfig => {
    const [paramValue, ...rest] = useReportSortingParam();
    const value = isEmpty(paramValue) ? reportConfig?.defaultGridSort || emptySorting : paramValue;

    return [value, ...rest];
};
